module.exports = __webpack_public_path__ + "static/media/bluebanana.49b2d841.png";